import { Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useFormContext } from "react-hook-form";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";

export const CardRewards: React.FC<any> = React.memo((props) => {
  const columns: IColumns[] = [
       
    {
      header: "Condition Value",
      fieldName: "",
      tooltip: true,
      type: "link",
    },
    {
      header: "Condition",
      fieldName: "",
      tooltip: true,
    },
    {
        header: "Reward Value",
        fieldName: "",
        tooltip: true,
    },
    {
        header: "Reward",
        fieldName: "",
        tooltip: true,
    },
   
  ];
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      <WSDataGrid
              id="cardrewardgrid"
              // title="Order Summary"
              columns={columns}
            /> 
      </Grid>
    </Grid>
  );
});
